import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconInvite: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconInvite"><Path d="M15 7H9V9H15V7Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M20 2H4V10.2792L2 9.61258V21H22V9.61258L20 10.2792V2ZM18 10.9459V4H6V10.9459L12 12.9459L18 10.9459Z" fill="currentColor"/></CentralIconBase>;
});

export default IconInvite;
